/* Airwheel Schweiz – Interaktionen: Warenkorb-Mengen/Upsell, Scroll-Animationen, Zähler, rotierende Headline, Cookie-Banner */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Warenkorb: Mengen, Entfernen, Doppelpack-Upsell (Drawer + Seite) ---------- */
  function html(str, sel) {
    var el = new DOMParser().parseFromString(str, 'text/html').querySelector(sel);
    return el ? el.innerHTML : null;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-aw-line][data-aw-set]');
    if (!b) return;
    e.preventDefault();
    var box = b.closest('[data-aw-cart]');
    var drawer = document.getElementById('Cart-Drawer');
    var imDrawer = drawer && drawer.contains(b);
    if (box) box.classList.add('aw-loading');
    fetch((window.theme && theme.routes.cart_change_url) || '/cart/change', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(b.dataset.awLine, 10), quantity: Math.max(0, parseInt(b.dataset.awSet, 10)),
        sections: ['cart-drawer', 'cart-bubble'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (s) {
      if (!imDrawer) { window.location.reload(); return; }
      awRender(drawer, s);
      return;
      if (s.sections) {
        var neu = html(s.sections['cart-drawer'], '.aw-drawer__content');
        var c = drawer.querySelector('.aw-drawer__content');
        if (c && neu !== null) c.innerHTML = neu;
        var kopf = html(s.sections['cart-drawer'], '.aw-drawer__head h6');
        var h = drawer.querySelector('.aw-drawer__head h6');
        if (h && kopf !== null) h.innerHTML = kopf;
        var bubble = document.querySelector('#cart-drawer-toggle .float_count');
        var nb = html(s.sections['cart-bubble'], '.float_count');
        if (bubble && nb !== null) bubble.innerHTML = nb;
        if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) { try { Shopify.PaymentButton.init(); } catch (err) {} }
      }
    }).catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (box) box.classList.remove('aw-loading'); });
  });


  function awRender(drawer, s) {
    if (!s || !s.sections || !drawer) return;
    var neu = html(s.sections['cart-drawer'], '.aw-drawer__content');
    var c = drawer.querySelector('.aw-drawer__content');
    if (c && neu !== null) c.innerHTML = neu;
    var kopf = html(s.sections['cart-drawer'], '.aw-drawer__head h6');
    var h = drawer.querySelector('.aw-drawer__head h6');
    if (h && kopf !== null) h.innerHTML = kopf;
    var bubble = document.querySelector('#cart-drawer-toggle .float_count');
    var nb = html(s.sections['cart-bubble'], '.float_count');
    if (bubble && nb !== null) bubble.innerHTML = nb;
    if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) { try { Shopify.PaymentButton.init(); } catch (err) {} }
  }
  /* Farbe eines Koffers im Warenkorb wechseln */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-aw-swap]');
    if (!b) return;
    e.preventDefault();
    var box = b.closest('[data-aw-cart]');
    var drawer = document.getElementById('Cart-Drawer');
    var imDrawer = drawer && drawer.contains(b);
    if (box) box.classList.add('aw-loading');
    var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    fetch('/cart/change.js', { method: 'POST', headers: H,
      body: JSON.stringify({ line: parseInt(b.dataset.awLine, 10), quantity: Math.max(0, parseInt(b.dataset.awQty, 10) - 1) })
    }).then(function (r) { if (!r.ok) throw 0; return fetch('/cart/add.js', { method: 'POST', headers: H,
      body: JSON.stringify({ items: [{ id: parseInt(b.dataset.awSwap, 10), quantity: 1 }], sections: ['cart-drawer', 'cart-bubble'], sections_url: window.location.pathname }) });
    }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (s) {
      if (!imDrawer) { window.location.reload(); return; }
      awRender(drawer, s);
    }).catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (box) box.classList.remove('aw-loading'); });
  });

  /* ---------- Scroll-Animationen (einmalig, dezent) ---------- */
  var SEL = '.aw-sec .aw-eyebrow,.aw-sec .aw-h2,.aw-sec .aw-lead,.aw-step,.aw-feat,.aw-spec,.aw-color,.aw-reel,.aw-bundle,.aw-faq details,.aw-card,.aw-rev,.aw-team__m,.aw-cmp,.aw-contact__box,.aw-usp__item';
  function reveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll(SEL);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('aw-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) return; /* schon sichtbar: nicht verstecken */
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.transitionDelay = (Math.min(sib, 5) * 70) + 'ms';
      el.classList.add('aw-rv'); io.observe(el);
    });
  }

  /* ---------- Zahlen hochzählen ---------- */
  function counters() {
    var els = document.querySelectorAll('[data-aw-count]');
    if (!els.length) return;
    function run(el) {
      var raw = el.getAttribute('data-aw-count');
      var m = raw.match(/^([\d.,]+)(.*)$/); if (!m) return;
      var num = parseFloat(m[1].replace(',', '.')), dec = (m[1].split(/[.,]/)[1] || '').length, suf = m[2];
      if (reduce) { el.textContent = raw; return; }
      var t0 = null, dur = 1300;
      function step(t) {
        if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur), v = num * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec).replace('.', ',') + suf;
        if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (el) {
      var m = el.getAttribute('data-aw-count').match(/^([\d.,]+)(.*)$/);
      if (m && !reduce) el.textContent = (m[1].indexOf(',') > -1 ? '0,0' : '0') + m[2];
      io.observe(el);
    });
  }

  /* ---------- Rotierende Headline (Höhe fix = längstes Wort, kein Layout-Sprung) ---------- */
  function rotator() {
    document.querySelectorAll('[data-aw-rot]').forEach(function (box) {
      var w = box.querySelectorAll('.aw-rot__w'); if (w.length < 2 || reduce) return;
      var i = 0;
      setInterval(function () {
        w[i].classList.remove('is-on'); w[i].classList.add('is-out');
        var alt = w[i]; setTimeout(function () { alt.classList.remove('is-out'); }, 600);
        i = (i + 1) % w.length; w[i].classList.add('is-on');
      }, 2600);
    });
  }

  /* ---------- Cookie-Banner über die Shopify Customer Privacy API ---------- */
  function consent() {
    var el = document.getElementById('aw-consent'); if (!el) return;
    function cp() { return window.Shopify && window.Shopify.customerPrivacy; }
    function open(prefs) {
      document.documentElement.classList.add('aw-consent-ready', 'aw-consent-open');
      el.hidden = false; el.classList.toggle('is-prefs', !!prefs);
      requestAnimationFrame(function () { el.classList.add('is-open'); });
    }
    function close() { document.documentElement.classList.remove('aw-consent-open'); el.classList.remove('is-open'); setTimeout(function () { el.hidden = true; }, 250); }
    function save(a, m, p) {
      var api = cp(); if (!api) { close(); return; }
      api.setTrackingConsent({ analytics: a, marketing: m, preferences: p, sale_of_data: m }, function () { close(); });
    }
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-aw-c]'); if (!b) return;
      var k = b.getAttribute('data-aw-c');
      if (k === 'all') save(true, true, true);
      if (k === 'none') save(false, false, false);
      if (k === 'prefs') el.classList.add('is-prefs');
      if (k === 'save') save(el.querySelector('#aw-c-a').checked, el.querySelector('#aw-c-m').checked, el.querySelector('#aw-c-p').checked);
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-aw-consent-open]')) { e.preventDefault(); open(true); }
    });
    if (!window.Shopify || !window.Shopify.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err) return; /* Fallback: Shopify-eigenes Banner bleibt aktiv */
      var api = cp();
      try {
        var c = api.currentVisitorConsent ? api.currentVisitorConsent() : {};
        if (c) {
          el.querySelector('#aw-c-a').checked = c.analytics === 'yes';
          el.querySelector('#aw-c-m').checked = c.marketing === 'yes';
          el.querySelector('#aw-c-p').checked = c.preferences === 'yes';
        }
        var offen = c && !c.analytics && !c.marketing && !c.preferences;
        if (api.shouldShowBanner && api.shouldShowBanner()) { open(false); return; }
        /* Shopify zeigt sein eigenes Banner? Dann ersetzen wir es durch unseres. */
        if (offen) {
          var n = 0, iv = setInterval(function () {
            n++;
            if (document.getElementById('shopify-pc__banner')) { clearInterval(iv); open(false); }
            if (n > 60) clearInterval(iv);
          }, 250);
        }
      } catch (e2) {}
    });
  }


  /* ---------- Hero-Video erst nach dem Laden (Poster bleibt LCP) ---------- */
  function heroVideo() {
    var v = document.querySelector('video[data-aw-lazyvideo]'); if (!v) return;
    var los = function () {
      if (v.src) return; v.src = v.getAttribute('data-src');
      v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    };
    if (reduce) return;
    var t = setTimeout(function () { (window.requestIdleCallback || setTimeout)(los); }, 6000);
    ['touchstart', 'scroll', 'pointerdown'].forEach(function (ev) { window.addEventListener(ev, function () { clearTimeout(t); los(); }, { once: true, passive: true }); });
  }
  function init() { reveal(); counters(); rotator(); consent(); if (window.matchMedia('(min-width: 990px)').matches) document.querySelectorAll('details[data-aw-open-desktop]').forEach(function (d) { d.open = true; }); if (document.readyState === 'complete') heroVideo(); else window.addEventListener('load', heroVideo); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
